import { render } from "./Reef.vue?vue&type=template&id=13e75d81"
import script from "./Reef.vue?vue&type=script&lang=js"
export * from "./Reef.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__